import { render } from "./Edit-Sucursal.vue?vue&type=template&id=133ef5d0&scoped=true"
import script from "./Edit-Sucursal.vue?vue&type=script&lang=js"
export * from "./Edit-Sucursal.vue?vue&type=script&lang=js"

import "./Edit-Sucursal.vue?vue&type=style&index=0&id=133ef5d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133ef5d0"]])

export default __exports__